'use strict';

var ONIBUS = ONIBUS || {
  data: {
    url: '',
    $body: $('body'),
    $window: $(window),
    $MQ: 'LANDSCAPE',
    scrollTop: 0,
    lockTop: 0,
    winW: '',
    winH: '',
    jqXHR: '',
    scrollTopflag: false,
    transitonEnd: 'webkitTransitionEnd mozTransitionEnd msTransitionEnd oTransitionEnd transitionend',
    animationStart: 'webkitAnimationStart mozAnimationStart msAnimationStart oAnimationStart animationStart',
    animationEnd: 'webkitAnimationEnd mozAnimationEnd msAnimationEnd oAnimationEnd animationEnd'
  },
  common: {
    init: {}
  }
};

ONIBUS.common = function (pageScript) {
  // コンストラクタ  =================================================================
  function init(pageScript) {
    setUtilityData();
    setBrowser();
    // initBeautifyJson();

    $('.anchorLink')[0] && initAnchorLink();
    $('.js-accordionHead')[0] && initAccordion();
    $('.js-headerToggle')[0] && initHeaderToggle();
    $('.js-headerSearch')[0] && initSearchToggle();

    pageScript && pageScript();
  }

  // public functions  ==========================================================
  /*
  *   UtilityDataの取得
  *   特定ページのみで使用するデータはページJSで取得すること。
  *
  */
  function setUtilityData() {
    ONIBUS.data.url = window.location.pathname;

    getScrollTop();
    ONIBUS.data.$window.on('scroll', getScrollTop);

    getWindowSize();
    ONIBUS.data.$window.on('resize', function () {
      getWindowSize();
    });
  }
  var scrollFlag = false;
  function getScrollTop() {
    if (!scrollFlag) {
      requestAnimationFrame(function () {
        scrollFlag = false;
        ONIBUS.data.$window.trigger('scroll.custom');
        ONIBUS.data.scrollTop = ONIBUS.data.$window.scrollTop();
      });
      scrollFlag = true;
    }
    return true;
  }

  function getWindowSize() {
    ONIBUS.data.winW = ONIBUS.data.$window.width();
    ONIBUS.data.winH = ONIBUS.data.$window.height();

    var cssContent = $('body').css('content');
    if (cssContent.indexOf('portrait') != -1) {
      ONIBUS.data.$MQ = 'PORTRAIT';
    } else {
      ONIBUS.data.$MQ = 'LANDSCAPE';
    }

    if (ONIBUS.data.oldMQ && ONIBUS.data.oldMQ !== ONIBUS.data.$MQ) {
      ONIBUS.data.$window.trigger('onBreakpointChange');
    }

    ONIBUS.data.oldMQ = ONIBUS.data.$MQ;
  }
  // HO TO USE
  // ONIBUS.data.$window.on('onBreakpointChange', 実行文);


  /*
  *
  *  ブラウザ判定
  *
  */
  function setBrowser() {
    ONIBUS.data.ua = {
      Safari: typeof window.chrome == 'undefined' && 'WebkitAppearance' in document.documentElement.style,
      Firefox: 'MozAppearance' in document.documentElement.style,
      IE: window.navigator.userAgent.toLowerCase().indexOf('msie') !== -1 || window.navigator.userAgent.toLowerCase().indexOf('trident') !== -1,
      IE9: window.navigator.appVersion.toLowerCase().indexOf('msie 9.') !== -1,
      ltIE9: typeof window.addEventListener === 'undefined' && typeof document.getElementsByClassName === 'undefined',
      Touch: typeof document.ontouchstart !== 'undefined',
      Pointer: window.navigator.pointerEnabled,
      MSPoniter: window.navigator.msPointerEnabled,
      Windows: window.navigator.userAgent.toLowerCase().indexOf('win') !== -1,
      Mac: window.navigator.userAgent.toLowerCase().indexOf('mac') !== -1,
      Mobile: window.navigator.userAgent.toLowerCase().indexOf('iphone') > 0 || window.navigator.userAgent.toLowerCase().indexOf('ipod') > 0 || window.navigator.userAgent.toLowerCase().indexOf('android') > 0 && window.navigator.userAgent.toLowerCase().indexOf('mobile') > 0,
      Tablet: window.navigator.userAgent.toLowerCase().indexOf('ipad') > 0 || window.navigator.userAgent.toLowerCase().indexOf('macintosh') > 0 && 'ontouchend' in document || window.navigator.userAgent.toLowerCase().indexOf('android') > 0 && window.navigator.userAgent.toLowerCase().indexOf('mobile') == -1
    };
    if (ONIBUS.data.ua.Safari) {
      $('html').addClass('safari');
    }
    if (ONIBUS.data.ua.Firefox) {
      $('html').addClass('firefox');
    }
    if (ONIBUS.data.ua.IE) {
      $('html').addClass('ie');
    }
    if (ONIBUS.data.ua.IE9) {
      $('html').addClass('ie9');
    }
    if (ONIBUS.data.ua.ltIE9) {
      $('html').addClass('ie8');
    }
    if (ONIBUS.data.ua.Tablet) {
      $('html').addClass('tablet');
    }
  }

  // event functions  =================================================================
  /*
  *
  *  アンカーリンク
  *
  */
  function initAnchorLink() {
    $('.anchorLink').on('click', function () {

      var href = $(this).attr("href"),
          target = $(href === "#" || href === "" ? 'html' : href),
          offset = target.offset().top,
          scrollOffset = Number(target.attr('data-scroll-offset')) || '0';

      $('html, body').animate({ scrollTop: offset - scrollOffset }, 500);

      return false;
    });
  }

  // ページごと読み込み event functions  ==========================================================

  /*
  *
  *
  *   ストレージ set・get
  *
  */
  // セッションストレージ - セット
  function setSessionStrage(key, value) {
    if (!window.sessionStorage) return;
    try {
      sessionStorage.setItem(key, value);
    } catch (err) {}
  }
  // ローカルストレージ - セット
  function setLocalStrage(key, value) {
    if (!window.localStorage) return;
    try {
      localStorage.setItem(key, value);
    } catch (err) {}
  }
  // セッションストレージ - ゲット
  function getSessionStrage(targetStrage) {
    var strage;
    if (!window.sessionStorage) return;
    try {
      strage = window.sessionStorage.getItem(targetStrage);
    } catch (err) {}
    return strage;
  }
  // ローカルストレージ - ゲット
  function getLocalStrage(targetStrage) {
    var strage;
    if (!window.localStorage) return;
    try {
      strage = window.localStorage.getItem(targetStrage);
    } catch (err) {}
    return strage;
  }

  /*
  *
  *   画像読み込み数カウンタ
  *   @target - jQueryオブジェクトで指定。指定された要素内のimgのロードを監視する。
  *   promiseを返すので、戻り値に対して.doneでコールバックを実装する。
  */
  function countImgLoaded(target, runnninng) {
    var deferred = new $.Deferred();

    var $img = target ? target.find('img') : $('img');
    var total = $img.length;
    var count = 0;

    $img.each(function () {
      var myImg = new Image();

      myImg.src = $(this).attr('src');

      myImg.onload = function () {
        count++;

        var progress = count / total;
        if (runnninng) {
          runnninng(progress);
        }

        if (count >= total) {
          deferred.resolve();
        }
      };
      myImg.onerror = function () {
        deferred.reject();
      };
    });

    return deferred.promise();
  }

  /*
  * スクロールロック
  *
  */
  function screenLock() {
    $('html').addClass('scrollLock');
  };
  function screenUnlock() {
    $('html').removeClass('scrollLock');
  };
  /*
  * アコーディオン
  *
  */
  var initAccordion = function initAccordion() {
    $('.js-accordionHead, .js-accordionClose').on('click', toggleAccordion);
  };
  var toggleAccordion = function toggleAccordion(e) {
    var wrapper = $(e.target).parents('.js-accordionWrapper');

    // PC表示のフッターのメニューはreturnする
    if (wrapper.hasClass('js-accordionWrapper-footer') && ONIBUS.data.$MQ === 'LANDSCAPE') return;

    if (wrapper.hasClass('is-accordion-open')) {
      wrapper.removeClass('is-accordion-open');
    } else {
      wrapper.addClass('is-accordion-open');
    }
    wrapper.find('.js-accordionContent').slideToggle();
  };
  /*
  * ヘッダー開閉
  *
  */
  var initHeaderToggle = function initHeaderToggle() {
    $('.js-headerToggle').on('click', toggleHeader);
  };
  var toggleHeader = function toggleHeader(e) {
    var wrapper = $('.js-headerWrapper');
    if (wrapper.hasClass('is-menu-open')) {
      wrapper.removeClass('is-menu-open');
      screenUnlock();
    } else {
      wrapper.addClass('is-menu-open');
      screenLock();
    }
    $('.js-headerMenu').slideToggle();
  };
  /*
  * 検索モーダル トグル
  *
  */
  var initSearchToggle = function initSearchToggle() {
    $('.js-headerSearch').on('click', function () {
      screenLock();
    });
    $('.js-headerSearch_modalOverlay').on('click', closeSeach);
    $('.js-searchModal_close').on('click', closeSeach);
  };
  var closeSeach = function closeSeach(e) {
    $('.js-headerSearch_container').removeAttr('open');
    screenUnlock();
  };

  /*
  *
  *  JSONのログを整形
  *
  */
  function initBeautifyJson() {
    var jsonText = $('.js-preJson').text();
    var jsonTextParse = JSON.parse(jsonText);
    var beautifyText = JSON.stringify(jsonTextParse, null, 2);
    $('.js-preJson').html('\uD83C\uDF3C ' + beautifyText);
  }

  return {
    setSessionStrage: setSessionStrage,
    setLocalStrage: setLocalStrage,
    getSessionStrage: getSessionStrage,
    getLocalStrage: getLocalStrage,
    countImgLoaded: countImgLoaded,
    screenLock: screenLock,
    screenUnlock: screenUnlock,
    init: init
  };
}();